import { Subject } from "rxjs";
import { Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { AppState } from "../store/index.selector";
import { slideDownUp } from "../shared/animations";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { UserRoles } from "../shared/enums/user-roles";

@Component({
  selector: "sidebar",
  templateUrl: "./sidebar.html",
  animations: [slideDownUp],
  standalone: false,
})
export class SidebarComponent implements OnInit, OnDestroy {
  active = false;
  activeDropdown: string[] = [];
  parentDropdown: string = "";
  userRole: string = "";
  roles = UserRoles;

  private destroy$ = new Subject<void>();

  constructor(
    public translate: TranslateService,
    public storeData: Store<AppState>,
    public router: Router,
  ) {}

  ngOnInit() {
    this.setActiveDropdown();
    this.storeData
      .select(state => state.auth.user!.role)
      .pipe(takeUntil(this.destroy$))
      .subscribe((role) => {
        this.userRole = role;
      });
  }

  setActiveDropdown() {
    const selector = document.querySelector(
      `.sidebar ul a[routerLink="${window.location.pathname}"]`,
    );
    if (selector) {
      selector.classList.add("active");
      const ul: any = selector.closest("ul.sub-menu");
      if (ul) {
        let ele: any
          = ul.closest("li.menu").querySelectorAll(".nav-link") || [];
        if (ele.length) {
          ele = ele[0];
          setTimeout(() => {
            ele.click();
          });
        }
      }
    }
  }

  toggleMobileMenu() {
    if (window.innerWidth < 1024) {
      this.storeData.dispatch({ type: "toggleSidebar" });
    }
  }

  toggleAccordion(name: string) {
    if (this.activeDropdown.includes(name)) {
      this.activeDropdown = this.activeDropdown.filter(d => d !== name);
    }
    else {
      this.activeDropdown.push(name);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
